export default __webpack_public_path__ + "static/media/SacolasDeCompras.4c021eff.png";